import React, { useEffect } from "react";
import { Drawer, Form, Input, DatePicker, Button, message, Row, Col } from "antd";
import moment from "moment";

const OfferForm = ({ open, setOpen, initialValue, isEdit, onSubmit }) => {
  const [form] = Form.useForm();

  useEffect(() => {
    if (open) {
      if (isEdit && initialValue) {
        form.setFieldsValue({
          ...initialValue,
          validFrom: moment(initialValue.validFrom),
          validUntil: moment(initialValue.validUntil),
        });
      } else {
        form.resetFields();
      }
    }
  }, [isEdit, initialValue, open]);
  const onFinish = async (values) => {
    try {
      const payload = {
        ...values,
        validFrom: values.validFrom?.startOf("day").format("YYYY-MM-DD"), // Local start of the day
        validUntil: values.validUntil?.endOf("day").format("YYYY-MM-DD"), // Local end of the day
      };
      await onSubmit(payload);
      form.resetFields();
      setOpen(false);
    } catch (error) {
      console.error("Error submitting offer:", error);
      message.error(error.response?.data?.message);
    }
  };
  
  return (
    <Drawer
      title={isEdit ? "Edit Offer" : "Add Offer"}
      width={500}
      placement="right"
      onClose={() => setOpen(false)}
      open={open}
    >
      <Form form={form} layout="vertical" onFinish={onFinish}>
        <Form.Item
          label="Offer Type"
          name="offerType"
          rules={[{ required: true, message: "Please enter the offer type!" }]}
        >
          <Input />
        </Form.Item>

        <Form.Item
          label="Bank Name"
          name="bankName"
          rules={[{ required: true, message: "Please enter the bank name!" }]}
        >
          <Input />
        </Form.Item>

        <Form.Item
          label="Offer Details"
          name="offerDetails"
          rules={[{ required: true, message: "Please enter the offer details!" }]}
        >
          <Input />
        </Form.Item>

        <Form.Item
          label="Conditions"
          name="conditions"
          rules={[{ required: true, message: "Please enter the conditions!" }]}
        >
          <Input />
        </Form.Item>

        <Row gutter={16}>
          <Col span={12}>
            <Form.Item
              label="Valid From"
              name="validFrom"
              rules={[{ required: true, message: "Please select the start date!" }]}
            >
              <DatePicker
                style={{ width: "100%" }}
                disabledDate={(current) =>
                  current && current.isBefore(moment().startOf("day"))
                }
              />
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item
              label="Valid Until"
              name="validUntil"
              rules={[
                { required: true, message: "Please select the end date!" },
                ({ getFieldValue }) => ({
                  validator(_, value) {
                    const validFrom = getFieldValue("validFrom");
                    if (!value || (validFrom && validFrom.isAfter(value, "day"))) {
                      return Promise.reject(
                        new Error("'Valid Until' must be after 'Valid From'.")
                      );
                    }
                    return Promise.resolve();
                  },
                }),
              ]}
            >
              <DatePicker
                style={{ width: "100%" }}
                disabledDate={(current) =>
                  current && current.isBefore(moment().startOf("day"))
                }
              />
            </Form.Item>
          </Col>
        </Row>

        <Form.Item>
          <Button type="primary" htmlType="submit" block>
            Save
          </Button>
        </Form.Item>
      </Form>
    </Drawer>
  );
};

export default OfferForm;
